import {
  Timestamp,
  addDoc,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
  collection,
} from "firebase/firestore";
import { AdminInvitesRef, AdminsRef, db, storage } from "../../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
// import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

export const usersSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value.firstName &&
        value.firstName.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.lastName &&
        value.lastName.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.userName &&
        value.userName.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const getAllAdmins = async (organizationId) => {
  try {
    const queryRef = query(
      AdminsRef,
      where("organization", "==", organizationId)
    );
    const response = await getDocs(queryRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getAdminByEmail = async (email) => {
  try {
    const queryRef = query(AdminsRef, where("email", "==", email));
    const querySnapshot = await getDocs(queryRef);
    if (querySnapshot.docs.length > 0) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const checkAdminExist = async (email) => {
  const q = query(AdminInvitesRef, where("invitedUserEmail", "==", email));

  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    const response = {
      data: querySnapshot.docs[0].data(),
      id: querySnapshot.docs[0].id,
      status: true,
    };
    return response;
  } else {
    return { status: false };
  }
};

export const addAdmin = async (data) => {
  return await addDoc(AdminsRef, data);
};

export const deleteAdmin = async (id) => {
  const adminsRef = doc(db, "admins", id);
  return await deleteDoc(adminsRef);
};
export const updateAdmin = async (id, adminDoc) => {
  const adminsRef = doc(db, "admins", id);
  return await updateDoc(adminsRef, adminDoc);
};

export const uploadAdminImageToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `admins/images/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const addAdminInvites = async (data) => {
  return await addDoc(AdminInvitesRef, data);
};

export const updateAdminInvite = async (data, id) => {
  const AdminInviteRef = doc(db, "adminInvites", id);
  return await updateDoc(AdminInviteRef, data);
};

export const getFilterAdminUsers = async (
  statusFilterOptions,
  roleFilterOptions,
  // dateAddedFilterOptions,
  // lastLoginDateFilterOptions,
  dateAddedRange,
  lastLogindateRange,
  setLoading,
  handleFilterModalClose,
  organization
) => {
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };

  try {
    setLoading(true);

    let results = [];

    const statusOptions =
      statusFilterOptions.length > 0 ? statusFilterOptions : [null];
    const roleOptions =
      roleFilterOptions.length > 0 ? roleFilterOptions : [null];

    for (const status of statusOptions) {
      for (const role of roleOptions) {
        let queries = [];

        if (status !== null) {
          queries.push(where("status", "==", status));
        }

        if (role !== null) {
          queries.push(where("role", "==", role));
        }
        
        if (
          dateAddedRange &&
          dateAddedRange.startDate &&
          dateAddedRange.endDate
        ) {
          queries.push(where("createdAt", ">=", dateAddedRange.startDate));
          queries.push(where("createdAt", "<=", dateAddedRange.endDate));
        }

        if (
          lastLogindateRange &&
          lastLogindateRange.startDate &&
          lastLogindateRange.endDate
        ) {
          queries.push(
            where("lastLoginDate", ">=", lastLogindateRange.startDate)
          );
          queries.push(
            where("lastLoginDate", "<=", lastLogindateRange.endDate)
          );
        }

        if (organization) {
          queries.push(where("organization", "==", organization));
        }

        if (queries.length > 0) {
          const q = query(AdminsRef, ...queries);
          const querySnapshot = await getDocs(q);

          const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
            return {
              id: doc.id,
              ...doc.data(),
            };
          });

          const queryResults = await Promise.all(fetchDetailsPromises);
          results = results.concat(queryResults);
        }
      }
    }

    // let queries = [
    //   ...statusFilterOptions.map((option) => where("status", "==", option)),
    //   ...roleFilterOptions.map((option) => where("role", "==", option)),
    // ];

    // queries.push(where("organization", "==", organization));

    // console.log("date added:", dateAddedRange);
    // console.log("last login date:", lastLogindateRange);

    // if (
    //   dateAddedRange &&
    //   dateAddedRange?.startDate &&
    //   dateAddedRange?.endDate
    // ) {
    //   queries.push(where("createdAt", ">=", dateAddedRange.startDate));
    //   queries.push(where("createdAt", "<=", dateAddedRange.endDate));
    // }
    // if (
    //   lastLogindateRange &&
    //   lastLogindateRange?.startDate &&
    //   lastLogindateRange?.endDate
    // ) {
    //   queries.push(where("lastLoginDate", ">=", lastLogindateRange.startDate));
    //   queries.push(where("lastLoginDate", "<=", lastLogindateRange.endDate));
    // }

    // const q = query(AdminsRef, ...queries);
    // const querySnapshot = await getDocs(q);

    // // Convert to map to handle async operations
    // const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
    //   return {
    //     id: doc.id,
    //     ...doc.data(),
    //   };
    // });

    // Wait for all fetches to complete
    // const results = await Promise.all(fetchDetailsPromises);

    const uniqueResults = deduplicate(results);
    handleFilterModalClose(); // Assuming it's appropriate to close the modal here
    return uniqueResults;
  } catch (error) {
    console.log("error filteing admins:", error.message);
  } finally {
    setLoading(false);
  }
};
